import {Component} from '@angular/core';

@Component({
  selector: 'mc-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
})
export class RadioButtonComponent {}
